import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getProviderWorktime, updateProviderWorktime } from "../slice/providerPanelWorktimeSlice";

const ProviderPanelWorktime = () => {
  const dispatch = useDispatch();
  const { providerWorktime } = useSelector((state) => state.providerWorktime);
  const [worktimeData, setWorktimeData] = useState([]);
  const providerToken = localStorage.getItem("provider_access_token");

  useEffect(() => {
    dispatch(getProviderWorktime(providerToken));
  }, [dispatch]);

  useEffect(() => {
    if (Array.isArray(providerWorktime) && providerWorktime.length > 0) {
      setWorktimeData(providerWorktime);
    } else {
      // Default: all 7 days with unchecked and 00:00:00 time
      const daysOfWeek = [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ];

      const defaultData = daysOfWeek.map((day, index) => ({
  id: index + 1,
  day,
  checked: "N",
  opening_hours: "",
  closing_hours: "",
}));

      setWorktimeData(defaultData);
    }
  }, [providerWorktime]);

const formatTime = (timeStr) => {
  if (!timeStr) return "--:--";

  const [hours, minutes] = timeStr.split(":");
  const date = new Date();
  date.setHours(Number(hours), Number(minutes), 0);

  return date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true, // or true if you prefer 12-hour format
  });
};

const generateTimeOptions = () => {
  const times = [""];
  for (let hour = 0; hour < 24; hour++) {
    const h = hour.toString().padStart(2, "0");
    times.push(`${h}:00:00`);
  }
  return times;
};


  const timeOptions = generateTimeOptions();

  const handleChange = (id, field, value) => {
    setWorktimeData((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };

  const parseTimeToMinutes = (timeStr) => {
    const [h, m] = timeStr.split(":").map(Number);
    return h * 60 + m;
  };

  const handleSubmit = async () => {

    // Validate times
    for (const day of worktimeData) {
      if (day.checked === "Y") {
        if (!day.opening_hours || !day.closing_hours) {
          toast.error(`Please select both start and end time for ${day.day}`);
          return;
        }

        const start = parseTimeToMinutes(day.opening_hours);
        const end = parseTimeToMinutes(day.closing_hours);

        if (end <= start) {
          toast.error(`End time must be after start time for ${day.day}`);
          return;
        }
      }
    }

    const result = await dispatch(updateProviderWorktime({ token: providerToken, worktimeData }));

    if (result.meta.requestStatus === "fulfilled") {
      toast.success("Worktime updated successfully!", {
        position: "top-right",
        autoClose: 2000,
        style: { fontSize: "0.85rem" },
      });
      dispatch(getProviderWorktime(providerToken));
    } else {
      toast.error("Failed to update worktime", {
        position: "top-right",
        autoClose: 2000,
        style: { fontSize: "0.85rem" },
      });
    }
  };

  return (
    <>
      <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
        <div className="ps-2 ps-lg-4">
          <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat">
            My work time                        
          </h4>
          <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-4 mywork-time">
            {/* Repeat this for each day */}
            {worktimeData.map((day) => (
            <div className="col" key={day.id}>
              <div className={`day-card p-4 ${day.checked === "Y" ? "active" : ""}`}>
                <h6 className="mb-2 font-size-16 font-weight-semibold text-uppercase">
                  {day.day}
                </h6>
                <input
                  type="checkbox"
                  checked={day.checked === "Y"}
                  onChange={(e) =>
                    handleChange(day.id, "checked", e.target.checked ? "Y" : "N")
                  }
                />
                <div className="row g-2">
                  <div className="col-6">
                    <label className="form-label font-size-16 font-weight-semibold">From</label>
                    <select
                      className="form-select"
                      disabled={day.checked !== "Y"}
                      value={day.opening_hours}
                      onChange={(e) => handleChange(day.id, "opening_hours", e.target.value)}
                    >
                      {timeOptions.map((time) => (
                        <option key={time} value={time}>
                          {formatTime(time)}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-6">
                    <label className="form-label font-size-16 font-weight-semibold">To</label>
                    <select
                      className="form-select"
                      disabled={day.checked !== "Y"}
                      value={day.closing_hours}
                      onChange={(e) => handleChange(day.id, "closing_hours", e.target.value)}
                    >
                      {timeOptions.map((time) => (
                        <option key={time} value={time}>
                          {formatTime(time)}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            ))}
            </div>
            <div className="row mt-4 pt-3">
              <div className="col-12 pt-2 text-center">
                <button
                  type="submit"
                  className="btn btn-custom-primary font-weight-medium font-size-16 text-capitalize px-4 rounded"
                  onClick={handleSubmit}>
                    <span className="d-block py-1">Save</span>
                </button>
              </div>
            </div>
          </div>
        </div>
    </>
  );
};

export default ProviderPanelWorktime;
